// Aplicar patches de segurança ANTES de tudo
import './security-patch';

require('./plugins');

import Vue from 'vue'
import VueCookies from 'vue-cookies';
import App from './App.vue'
import router from './router'
import store from './store'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import '@fortawesome/fontawesome-free/css/all.css'

// Layouts
import Layout from '@/components/Layout/Layout.vue';
import TableDefault from '@/components/Layout/TableDefault.vue';

Vue.component('layout', Layout);
Vue.component('table-default', TableDefault);

Vue.config.productionTip = false
Vue.use(VueCookies, { expires: '1d'})

// Handler global para promises não tratadas (incluindo timeouts)
window.addEventListener('unhandledrejection', event => {
  const reason = event.reason;
  
  // Trata timeout especificamente
  if (reason === 'Timeout' || 
      (reason && reason.statusText === 'Timeout') ||
      (reason && typeof reason === 'string' && reason.toLowerCase().includes('timeout'))) {
    
    console.error('Timeout detectado:', reason);
    
    // Converte string "Timeout" em Error object antes que o Sentry capture
    // Isso evita o erro "Non-Error promise rejection"
    if (typeof reason === 'string' && reason === 'Timeout') {
      const timeoutError = new Error('Tempo limite de conexão excedido. Por favor, tente novamente.');
      timeoutError.status = 0;
      timeoutError.statusText = 'Timeout';
      // Atualiza o reason do evento para ser um Error object
      Object.defineProperty(event, 'reason', {
        value: timeoutError,
        writable: true,
        configurable: true
      });
    }
    
    // Previne que o erro seja propagado para o Sentry se já foi tratado
    event.preventDefault();
    
    // Pode adicionar notificação ao usuário aqui se necessário
    // Exemplo: Vue.prototype.$buefy.toast.open({ ... })
  }
  
  // Converte outras rejeições não-Error em Error objects para evitar problemas com Sentry
  if (reason && !(reason instanceof Error)) {
    if (typeof reason === 'string') {
      const error = new Error(reason);
      Object.defineProperty(event, 'reason', {
        value: error,
        writable: true,
        configurable: true
      });
    }
  }
});

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", process.env.VUE_APP_SENTRY_TARGET, /^\//],
      tracingOrigins: ["*"]
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Converte rejeições não-Error em Error objects antes de enviar ao Sentry
  beforeSend(event, hint) {
    // Se for uma rejeição não tratada e o reason não for Error, converte
    if (event.exception && event.exception.values) {
      event.exception.values.forEach(exception => {
        if (exception.type === 'UnhandledRejection') {
          const originalReason = hint.originalException || hint.syntheticException;
          
          // Se o reason for a string "Timeout", converte em Error
          if (originalReason === 'Timeout' || 
              (typeof originalReason === 'string' && originalReason === 'Timeout')) {
            const timeoutError = new Error('Tempo limite de conexão excedido. Por favor, tente novamente.');
            timeoutError.status = 0;
            timeoutError.statusText = 'Timeout';
            
            // Atualiza a exception para ser um Error normal
            exception.type = 'Error';
            exception.value = timeoutError.message;
            
            // Adiciona informações extras
            if (!exception.data) {
              exception.data = {};
            }
            exception.data.status = 0;
            exception.data.statusText = 'Timeout';
            
            return event;
          }
          
          // Se for outra string não-Error, converte
          if (originalReason && !(originalReason instanceof Error)) {
            if (typeof originalReason === 'string') {
              const error = new Error(originalReason);
              exception.type = 'Error';
              exception.value = error.message;
            }
          }
        }
      });
    }
    return event;
  },
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')